<template>
  <div class="mt-4">
    <h1 class="title text-uppercase font-weight-bold">Editar dados dos produtos</h1>
    <hr class="linha-amarela" />

    <div class="row">
      <button class="btn btn-success update-category" v-if="updateCategories.length > 0" @click="showUpdateCategory()">
        Alterar categoria
      </button>

      <div class="col-2">
        <label>Id Produto Início:</label>
        <input type="number" class="form-control" v-model="fields.start" placeholder="######">
      </div>
      
      <div class="col-2">
        <label>Id Produto Fim:</label>
        <input type="number" class="form-control" v-model="fields.end" placeholder="######">
      </div>
      
      <div class="col-3">
        <label>Cód. barras:</label>
        <input type="text" class="form-control" v-model="fields.codbar" placeholder="############">
      </div>
      
      <div class="col-2">
        <label>Lojista ID:</label>
        <input type="number" class="form-control" v-model="fields.shopkeeperId" placeholder="######">
      </div>

      <div class="col-3 d-flex align-items-end">
        <button class="btn btn-primary btn-block w-100" @click="searchProductsPhotos()">Buscar</button>
      </div>

      <div class="col-12 mb-2 mt-2">
        <label>Categoria:</label>
        <span class="ml-2"><b>{{syncCategoria}}</b></span>
        <span class="btn btn-primary float-right mb-1" @click="syncLimparCategoria()">Limpar</span>

        <select class="form-control" @change="syncSelectId()" v-model="syncCategoriaSelect">
          <option selected value="">-- Selecione a categoria {{syncCount+1}} --</option>
          <option v-for="(item, i) in syncCategorias" :key="i" :value="item">
            {{item.nome_departamento}}
          </option>
        </select>
      </div>
    </div>

    <div class="row mt-4">
      <div class="col-12" v-for="(item, i) in products" :key="i">
        <div class="row" style="border-bottom: 2px solid #222;padding: 10px 0;">
            <div class="col-12">
              <h4 style="font-size: 18px">
                <span style="color: #222">
                  <input type="checkbox" class="mr-2" style="width:20px;height:20px" @click="setUpdateCategory(item.id, $event.target.checked)">
                  {{item.id}}
                </span> 
                <span> - {{item.produto}} - {{item.codbar}} - </span>
                <span style="color: #222">{{item.departamento}}</span>
                <span style="color: red" v-if="item.lojista_id"> - Lojista ID: {{item.lojista_id}}</span>
              </h4>
            </div>

            <div class="col-12 m-0 p-0 mt-1">
              <button class="btn btn-success btn-block" @click="savePhotoOrder(item)">Salvar ordem das fotos do produto</button>
            </div>

            <div v-for="(photo, index) in item.produto_fotos" :key="photo.id" class="mr-1 text-center">
              <input 
                type="number" 
                v-model="photo.order" 
                class="form-control" 
                min="1"
                @blur="updatePhotoOrder(item)"
              >
              <img 
                :src="urlPhoto(photo.foto_png)" 
                class="cursor-pointer" 
                width="150px" 
                @click="setPhoto(urlPhoto(photo.foto_png))">
              <button class="btn btn-danger btn-block" @click="deletePhoto(photo.id, index)">Excluir</button>
            </div>

            <div class="col-12 m-0 p-0">
              <button class="btn btn-primary btn-block" @click="editProduct(item)">
                Editar {{item.produto}}
              </button>
            </div>
        </div>
      </div>
    </div>

    <b-modal
      title="Foto"
      size="xl"
      id="viewPhotoProduct"
      header-bg-variant="orange"
      header-text-variant="light"
      centered
      hide-header
      hide-footer
    >      
      <div class="row">
        <div class="col-12 text-center">
          <img :src="photo" width="100%">
        </div>
      </div>
    </b-modal>

    <b-modal
      title="Detalhes do produto"
      size="xl"
      id="modalProduto"
      header-bg-variant="orange"
      header-text-variant="light"
      centered
      hide-footer
    >
      <b-row>
        <b-col cols="9" class="mb-2">
          <label>Nome do produto <span class="text-danger d-inline">*</span></label>
          <input type="text" class="form-control" v-model="dataProduct.produto" placeholder="Nome do produto">
          <span class="text-danger d-inline" v-if="error.produto">Informe o nome do produto</span>
        </b-col>

        <b-col cols="3" class="mb-2">
          <label>Código de barra <span class="text-danger d-inline">*</span></label>
          <input type="text" class="form-control" v-model="dataProduct.codbar" @blur="buscarCodBar()" placeholder="Código de barras">
          <span class="text-danger d-inline" v-if="error.codbar">Informe o Cód. barras</span>
        </b-col>

        <b-col cols="3" class="mb-2">
          <label>Marca <span class="text-danger d-inline">*</span></label>
          <input type="text" class="form-control" v-model="dataProduct.marca" placeholder="Marca do produto">
          <span class="text-danger d-inline" v-if="error.marca">Informe a marca</span>
        </b-col>

        <b-col cols="3" class="mb-2">
          <label>Unidade de medida <span class="text-danger d-inline">*</span></label>
          <input type="text" class="form-control" v-model="dataProduct.unidade" placeholder="Un, Kg, Cm...">
          <span class="text-danger d-inline" v-if="error.unidade">Informe a Unidade de medida</span>
        </b-col>

        <b-col cols="3" class="mb-2">
          <label>Peso (Kg)<span class="text-danger d-inline">*</span></label>
          <input type="text" class="form-control" v-model="dataProduct.peso" placeholder="Peso do produto" v-money="formatTipo">
          <span class="text-danger d-inline" v-if="error.peso">Informe o peso do produto</span>
        </b-col>

        <b-col cols="3" class="mb-2">
          <label>Altura (Cm)<span class="text-danger d-inline">*</span></label>
          <input type="text" class="form-control" v-model="dataProduct.altura" placeholder="Altura do produto" v-money="formatTipo">
          <span class="text-danger d-inline" v-if="error.altura">Informe a altura</span>
        </b-col>

        <b-col cols="3" class="mb-2">
          <label>Largura (Cm)<span class="text-danger d-inline">*</span></label>
          <input type="text" class="form-control" v-model="dataProduct.largura" placeholder="Largura do produto" v-money="formatTipo">
          <span class="text-danger d-inline" v-if="error.largura">Informe a largura</span>
        </b-col>

        <b-col cols="3" class="mb-2">
          <label>Comprimento (Cm)<span class="text-danger d-inline">*</span></label>
          <input type="text" class="form-control" v-model="dataProduct.comprimento" placeholder="Comprimento do produto" v-money="formatTipo">
          <span class="text-danger d-inline" v-if="error.comprimento">Informe o comprimento</span>
        </b-col>

        <b-col cols="3" class="mb-2">
          <label>Qtd Metro² Caixa<span class="ml-2 text-danger d-inline">(Pisos e revestimento)</span></label>
          <input type="text" class="form-control" v-model="dataProduct.qtd_metros" placeholder="quantidade de m² na caixa" v-mask="['#.##', '##.##']">
        </b-col>

        <b-col cols="12" class="mb-2">
          <label>Descrição do produto (Opcional)</label>
          <textarea class="form-control" rows="3" placeholder="Descrição do produto" v-model="dataProduct.descricao"></textarea>
        </b-col>

        <b-col cols="12" class="mb-2 mt-2">
          <label>Categoria: <span class="text-danger d-inline">*</span></label>
          <span class="ml-2"><b>{{categoria}}</b></span>
          <span class="btn btn-primary float-right mb-1" @click="limparCategoria()">Limpar</span>

          <select class="custom-select mb-3" @change="selectId()" v-model="categoriaSelect" v-show="validLink == false">
            <option selected value="">-- Selecione a categoria {{count+1}} --</option>
            <option v-for="(item, i) in categorias" :key="i" :value="item">{{item.nome_departamento}}</option>
          </select>
          <span class="text-danger d-inline" v-if="error.departamento_id">Informe a categoria</span>
        </b-col>

        <b-col cols="6" class="mt-2">
          <label>Ficha(s) tec. (Opcional)</label>
          <span class="btn btn-primary float-right" @click="openModalFicha()">+</span>

          <table class="table table-striped table-bordered mt-2">
            <thead>
              <tr>
                <th scope="col">Tipo</th>
                <th scope="col">Descrição</th>
                <th scope="col" class="text-center">Ação</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, i) in dataProduct.produto_fichas" :key="i" v-show="item.tipo != null">
                <td>{{item.tipo}}</td>
                <td>{{item.descricao}}</td>
                <td class="text-center">
                  <span class="cursor-pointer" style="color:red" @click="deleteRecord(i, item)">
                    <i class="fas fa-trash"></i>
                  </span>
                </td>
              </tr>
              <tr v-if="dataProduct.produto_fichas && dataProduct.produto_fichas.length == 0">
                <td colspan="3">
                  <span>Sem ficha tec. cadastrada!</span>
                </td>
              </tr>
            </tbody>
          </table>
        </b-col>

        <b-col cols="6" class="mt-2">
          <label>Imagem do produto:</label>
          <input type="file" id="file" ref="file" accept="image/*" @change="uploadImage()" class="form-control">
          <span class="text-danger d-inline" v-if="error.fotos">Informe a(s) foto(s)</span>

          <b-row>
            <b-col cols="2" class="mt-2 mr-2 text-center" v-for="(item, i) in dataProduct.produto_fotos" :key="i">
              <img 
                :src="urlPhoto(item.foto_png ? item.foto_png : item)"
                @click="setPhoto(urlPhoto(item.foto_png ? item.foto_png : item))"
                width="70" 
                class="cursor-pointer"
              >
            </b-col>
          </b-row>
        </b-col>

        <b-col cols="12" class="text-center mt-4 mb-2">
          <button class="btn btn-success btn-block" @click="updateProduct()">Atualizar produto</button>
        </b-col>
      </b-row>
    </b-modal>

    <b-modal
      title="Nova ficha tec."
      size="md"
      id="modalFicha"
      header-bg-variant="orange"
      header-text-variant="light"
      centered
      hide-footer
    >
      <b-row>
        <b-col cols="6" class="mb-2">
          <label>Tipo:</label>
          <input type="text" class="form-control" v-model="tipo" placeholder="Ex: Cor:">
        </b-col>

        <b-col cols="6" class="mb-2">
          <label>Descrição:</label>
          <input type="text" class="form-control" v-model="descricao" placeholder="Ex: Azul">
        </b-col>

        <b-col cols="12" class="mt-2 text-center">
          <button class="btn btn-success" @click="addFicha()">Salvar ficha tec.</button>
        </b-col>
      </b-row>
    </b-modal>

    <b-modal
      title="Alterando categoria do(s) produto(s) selecionado(s)"
      size="xl"
      id="updateCategories"
      header-bg-variant="orange"
      header-text-variant="light"
      centered
      hide-footer
    >
      <div class="row">
        <div class="col-12 mb-2 mt-2">
          <label>Categoria:</label>
          <span class="ml-2"><b>{{updateCategoria}}</b></span>
          <span class="btn btn-primary float-right mb-1" @click="updateLimparCategoria()">Limpar</span>

          <select class="form-control" @change="updateSelectId()" v-model="updateCategoriaSelect">
            <option selected value="">-- Selecione a categoria {{updateCount+1}} --</option>
            <option v-for="(item, i) in updateCategorias" :key="i" :value="item">
              {{item.nome_departamento}}
            </option>
          </select>
        </div>

        <div class="col-12 mt-4 text-center">
          <button class="btn btn-success" :disabled="updateSetLink == false" @click="sendUpdateCategory()">
            Atualizar categoria
          </button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import makeToast from "../../mixins/makeToast";

export default {
  name: 'DeletePhotoProduct',
  mixins: [makeToast],

  data() {
    return {
      photo: '',
      fields: {
        start: '',
        end: '',
        codbar: '',
        shopkeeperId: '',
        categoryId: ''
      },
      updateCategories: [],
      products: [],
      dataProduct: {
        produto: null,
        codbar: null,
        marca: null,
        uni_med: null,
        peso: null,
        altura: null,
        largura: null,
        comprimento: null,
        departamento_id: null,
        aprovar: false,
        qtd_metros: null,
        produto_fichas: [],
        produto_fichas_remover: [],
        produto_fotos: [],
        produto_fotos_remover: []
      },
      error: {
        produto: false,
        codbar: false,
        marca: false,
        uni_med: false,
        peso: false,
        altura: false,
        largura: false,
        comprimento: false,
        departamento_id: false,
        fichas: false,
        fotos: false
      },
      formatTipo: {
        decimal: '.',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 2,
        masked: true
      },
      categoriaSelect: '',
      categoria: '',
      categorias: [],
      count: 0,
      tipo: null,
      corbar: null,
      validLink: true,
      descricao: null,
      valid: false,
      syncSetLink: false,
      syncCount: 0,
      syncCategoriaSelect: '',
      syncCategoria: '',
      syncCategorias: [],

      updateCategoriasLoading: true,
      updateCategorias: [],
      updateSetLink: false,
      updateCount: 0,
      updateCategoriaSelect: '',
      updateCategoria: ''
    };
  },

  created() {
    this.getCategoriaLojista(0);
  },

  methods: {
    setUpdateCategory(id, check) {
      if (check) {
        this.updateCategories.push(id);
      } else {
        this.updateCategories = this.updateCategories.filter(categoryId => categoryId !== id);
      }
    },
    showUpdateCategory() {
      this.$bvModal.show('updateCategories');
    },
    sendUpdateCategory() {
      const data = {
        itens: this.updateCategories,
        category: this.updateCategoriaSelect
      }

      this.$store.dispatch('startLoader');
      this.$store.dispatch('shopkeeper/sendUpdateCategory', data)
        .then(() => {
          this.$store.dispatch('endLoader');
          this.$bvModal.hide('updateCategories');
          this.updateCategories = [];
          this.products = [];
          this.updateLimparCategoria();
          this.searchProductsPhotos();

          this.makeToast('Sucesso!', 'Categoria do(s) produto(s) atualizado!', 'success');
        })
        .catch(() => {
          this.$store.dispatch('endLoader');
        });
    },
    getUpdateCategoria(id) {
      this.$store.dispatch('startLoader');
      this.$store.dispatch('shopkeeper/buscarCategorias', id)
        .then((response) => {
          this.updateCategorias = response.data;
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
        });
    },
    updateLimparCategoria() {
      this.updateSetLink = false;
      this.updateCount = 0;
      this.updateCategoriaSelect = '';
      this.updateCategoria = '';

      this.getUpdateCategoria(0);
    },
    updateSelectId() {
      const item = this.updateCategoriaSelect;

      if(item && item.nome_departamento) {
        if(this.updateSetLink == false) {
          const seta = this.updateCount == 0 ? '' : ' -> ';            
          this.updateCategoria = this.updateCategoria+seta+item.nome_departamento;
        } else {
          const partes = this.updateCategoria.split(' -> ');

          partes.pop();
          partes.push(item.nome_departamento);
          
          this.updateCategoria = partes.join(' -> ');
        }
      }

      if(item.link == true) {
        this.updateSetLink = true;
      } else {
        
        if(item && item.nome_departamento) {

          this.updateCount = this.updateCount +1;
          this.updateCategoriaSelect = '';

          this.getCategoriaLojista(item.id);

          this.updateSetLink = false;
        }
      }
    },
    syncLimparCategoria() {
      this.syncSetLink = false;
      this.syncCount = 0;
      this.syncCategoriaSelect = '';
      this.syncCategoria = '';
      this.fields.categoryId = '';

      this.getCategoriaLojista(0);
    },
    getCategoriaLojista(id) {
      this.$store.dispatch('startLoader');
      this.$store.dispatch('shopkeeper/buscarCategorias', id)
        .then((response) => {
          this.syncCategorias = response.data;

          if (this.updateCategoriasLoading) {
            this.updateCategorias = response.data;
          }
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
        });
    },
    syncSelectId() {
      const item = this.syncCategoriaSelect;

      if(item && item.nome_departamento) {
        if(this.syncSetLink == false) {
          const seta = this.syncCount == 0 ? '' : ' -> ';            
          this.syncCategoria = this.syncCategoria+seta+item.nome_departamento;
        } else {
          const partes = this.syncCategoria.split(' -> ');

          partes.pop();
          partes.push(item.nome_departamento);
          
          this.syncCategoria = partes.join(' -> ');
        }
      }

      if(item.link == true) {
        this.syncSetLink = true;
        this.fields.categoryId = item.id;

        this.searchProductsPhotos();
      } else {
        
        if(item && item.nome_departamento) {

          this.syncCount = this.syncCount +1;
          this.syncCategoriaSelect = '';

          this.getCategoriaLojista(item.id);

          this.syncSetLink = false;
        }
      }
    },
    editProduct(item) {
      this.limpaErro();

      this.dataProduct = item;
      this.corbar = item.codbar;
      this.categoria = item.departamento;
      this.validLink = true;

      this.$bvModal.show('modalProduto');
    },
    updateProduct() {
      this.dataProduct.qtd_metros = this.dataProduct.qtd_metros > 0 ? this.dataProduct.qtd_metros : null; 
      this.dataProduct.admin = true;

      this.$store.dispatch('startLoader');
      this.$store.dispatch('admin/bucarNovoUpStatusRequest', this.dataProduct)
        .then((response) => {
          if(response.data.error == false) {
            this.makeToast('Sucesso!', 'Produto atualizado!', 'success');

            this.limpaProduto();
            this.searchProductsPhotos();
            this.$bvModal.hide('modalProduto');
          } else {
            this.makeToast('Opss!', 'Não foi possíve alterar o produto!', 'danger');
          }
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
        });
    },
    deleteRecord(i, item) {
      if(!this.dataProduct.produto_fichas_remover) {
        this.dataProduct.produto_fichas_remover = [];
      }
      
      this.dataProduct.produto_fichas_remover.push(item);
      this.dataProduct.produto_fichas = this.dataProduct.produto_fichas.filter((elemento, index) => index !== i);
    },
    selectId() {
      const item = this.categoriaSelect;

      const seta = this.count == 0 ? '' : ' -> ';
      
      this.categoria = this.categoria+seta+item.nome_departamento;

      if(item.link == true) {
        this.validLink = true;
        this.dataProduct.departamento_id = item.id;
        this.error.departamento_id = false;
      } else {
        this.count = this.count +1;
        this.categoriaSelect = '';

        this.buscarCategoria(item.id);
      }
    },
    limparCategoria() {
      this.validLink = false;
      this.count = 0;
      this.categoriaSelect = '';
      this.categoria = '';
      this.dataProduct.departamento_id = null;

      this.buscarCategoria(0);
    },
    buscarCategoria(id) {
      this.$store.dispatch('startLoader');
      this.$store.dispatch('shopkeeper/buscarCategorias', id)
        .then((response) => {
          this.categorias = response.data;
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
        });
    },
    buscarCodBar() {
      if(this.corbar == this.dataProduct.codbar) {return}
      this.$store.dispatch('startLoader');
      this.$store.dispatch('shopkeeper/buscarCodBar', this.dataProduct.codbar)
        .then((response) => {
          if(response.data.id) {
            this.dataProduct.codbar = this.corbar;
            this.makeToast('Oops!', 'Esse código de barras já existe, informe outro!', 'danger');
          }
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
        });
    },
    uploadImage() {
      const formData = new FormData();
      this.imageSelected = this.$refs.file.files[0];
      formData.append('file', this.imageSelected);

      this.$store.dispatch('startLoader');
      this.$store.dispatch('files/uploadFileNewProduct', formData)
      .then((response) => {
        const file = response.data.data;
        this.dataProduct.produto_fotos.push(file)
      })
      .catch(() => {
        this.makeToast('Oops!', 'Não foi possível inserir a imagem, tente novamente!', 'danger');
      })
      .finally(() => {
        this.$store.dispatch('endLoader');
      });
    },
    openModalFicha() {
      this.tipo = null;
      this.descricao = null;
      this.$bvModal.show('modalFicha');
    },
    addFicha() {
      this.dataProduct.produto_fichas.push({tipo: this.tipo, descricao: this.descricao});
      this.$bvModal.hide('modalFicha');
    },
    limpaProduto(){
      this.dataProduct.produto = null;
      this.dataProduct.codbar = null;
      this.dataProduct.marca = null;
      this.dataProduct.unidade = null;
      this.dataProduct.peso = null;
      this.dataProduct.altura = null;
      this.dataProduct.largura = null;
      this.dataProduct.comprimento = null;
      this.dataProduct.descricao = null;
      this.dataProduct.departamento_id = null;
      this.dataProduct.qtd_metros = null;
      this.dataProduct.produto_fichas = [];
      this.dataProduct.produto_fotos = [];
      this.produto_fotos_remover = [];   
    },
    limpaErro(){
      this.error.produto = false;
      this.error.codbar = false;
      this.error.marca = false;
      this.error.unidade = false;
      this.error.peso = false;
      this.error.altura = false;
      this.error.largura = false;
      this.error.comprimento = false;
      this.error.departamento_id = false;
      this.error.produto_fichas = false;
      this.error.produto_fotos = false;        
    },
    deletePhoto(id, index) {
      this.$store.dispatch('startLoader');
      this.$store.dispatch('admin/deleteProductPhoto', id)
        .then(() => {
          this.makeToast('Sucesso', 'Foto apaga com sucesso!', 'success');

          const product = this.products.find(product => 
            product.produto_fotos.some(photo => photo.id === id)
          );

          if (product) {
            product.produto_fotos.splice(index, 1);
          }
        })
        .catch(() => {
          this.makeToast('Erro', 'Erro ao apagar foto!', 'danger');
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
        });      
    },
    savePhotoOrder(data) {
      this.$store.dispatch('startLoader');
      this.$store.dispatch('admin/saveProductOrder', data)
        .then(() => {
          this.makeToast('Sucesso', 'Ordem salva com sucesso!', 'success');
          this.searchProductsPhotos();
        })
        .catch(() => {
          this.makeToast('Erro', 'Erro ao salvar ordem!', 'danger');
          this.$store.dispatch('endLoader');
        });
    },
    urlPhoto(path) {
      return process.env.VUE_APP_FOTOS_URL + path;
    },
    setPhoto(url) {
      this.photo = url;
      this.$bvModal.show('viewPhotoProduct');
    },
    searchProductsPhotos() {
      this.$store.dispatch('startLoader');
      this.$store.dispatch('admin/searchProductsPhotos', this.fields)
        .then((response) => {
          this.products = response.data.map((item) => {
            item.produto_fotos = item.produto_fotos.map((photo, index) => ({
              ...photo,
              order: index + 1,
            }));
            return item;
          });
        })
        .catch(() => {
          this.makeToast('Erro', 'Erro ao buscar dados!', 'danger');
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
        });
    },
    updatePhotoOrder(item) {
      item.produto_fotos.sort((a, b) => a.order - b.order);
    },
  },
};
</script>

<style scoped>
.update-category {
  position: fixed;
  z-index: 99;
  right: 25px;
  bottom: 50px;
  color: white;
  padding: 15px 20px;
  border: none;
  border-radius: 50px;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
  transition: 0.3s;
  animation: pulse 1.5s infinite;
}

@keyframes pulse {
  0% {
    transform: scale(1);
    box-shadow: 0 0 0 0 #28a746bd;
  }
  50% {
    transform: scale(1.1);
    box-shadow: 0 0 10px 10px rgba(255, 87, 51, 0);
  }
  100% {
    transform: scale(1);
    box-shadow: 0 0 0 0 rgba(255, 87, 51, 0);
  }
}

</style>